export default __webpack_public_path__ + "static/media/RedVolume-dsk.fc292cbb.png";